import React from 'react';
import { withRouter } from 'react-router-dom';

import { firebase } from '../../firebase';
import * as routes from '../../constants/routes';
import { toast } from 'react-toastify';
import { inject, observer } from 'mobx-react';
import { compose } from 'recompose';

const withAuthorization = (condition) => (Component) => {
  class WithAuthorization extends React.Component {

    componentDidMount() {
      this.fireBaseListener = firebase.auth.onAuthStateChanged(authUser => {
        if(authUser){
          authUser.getIdTokenResult().then((token)=>{
            let ans = condition(authUser, token);
            if (!ans) {
                this.props.history.push(routes.SIGN_IN);
                toast.error("Neturite prieigos", {
                  toastId:"NoAccess",
                  position: toast.POSITION.BOTTOM_RIGHT                  
                });
            }
          });
        }
        else{
          this.props.history.push(routes.SIGN_IN);
        }
        
      });
    }

    componentWillUnmount() {
      this.fireBaseListener && this.fireBaseListener();
      this.authListener = undefined;
   }

    render() {
      return this.props.sessionStore.authUser ? <Component /> : null;
    }
  }

  return compose(
    withRouter,
    inject('sessionStore'),
    observer
  )(WithAuthorization);
}

export default withAuthorization;


// WEBPACK FOOTER //
// ./src/components/Session/withAuthorization.js